/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('dialog_declineUserMemoCtrl', ['$rootScope', '$scope', '$http', 'NetworkService', 'MainService','Notification', function ($rootScope, $scope, $http, networkService, MainService,Notification) {

        $scope.declineUser = function ()
        {
            var data = MainService.getDialogData("dialog_declineUserMemo")
            var text = $scope.noteModel
            var email = data.email
            var schicht_id = data.schicht_id
            var position_id = data.position_id

            console.log("####")
            if (text == undefined)
            {
                Notification.error("Bitte gib eine Nachricht ein")
            } else
            {
                networkService.declineUserSchicht(email, schicht_id, position_id, text, function () {
                    $rootScope.$emit("repaint");
                });
                $scope.addNote(email, text)
                $("#dialog_declineUserMemo").modal("close")
            }
            /**/

        }

        $scope.addNote = function (email, text)
        {
            networkService.addNotification(email, text);
        }
    }])